import { CreateFundStep } from "./createFundInterfaces"

const FLOW = [
  'collect-name',
  'fund-name',
]

export function getPreviousStep(
  step: CreateFundStep,
  user: any
): CreateFundStep | '' {
  // const flow: any = getFlow(user)
  const flow = FLOW
  const indexCurrentStep = flow.indexOf(step)
  if (indexCurrentStep === 0) return ''

  const previous: any = flow[indexCurrentStep - 1]
  return previous
}

export function getNextStep(
  step: CreateFundStep,
  user: any
): CreateFundStep | '' {
  const flow = FLOW
  const indexCurrentStep = flow.indexOf(step)
  if (indexCurrentStep === flow.length - 1) return ''

  const next: any = flow[indexCurrentStep + 1]
  return next
}
